import axiosInstance from '../../../../config/axiosInstance';
const  IssueStatusService = {
    async GetAllIssueStatus(redirectCallback) {
        try {            
            const response = await axiosInstance.get(`/SuperAdmin/GetIssueStatusDefault`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteIssueStatus(ID,redirectCallback) {
        try {
           const response = await axiosInstance.get(`/SuperAdmin/DeleteIssueStatusDefault?ID=${ID}`);
           return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetDefaulIssueStatus(ID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SuperAdmin/SetDefaulIssueStatus?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetCloseIssueStatus(ID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SuperAdmin/SetCloseIssueStatus?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetCompleteIssueStatus(ID,redirectCallback) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SuperAdmin/SetCompleteIssueStatus?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default IssueStatusService;